import { HttpStatus } from '@/core/types/HttpStatus.ts'

export const httpStatus: HttpStatus = {
  BAD_REQUEST: 400,
  NOT_AUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  UNPROCESSABLE: 422,
  SERVER_ERROR: 500
}
